// Typed fetch helpers over the generated OpenAPI schema (`make types` regenerates schema.d.ts).
import type { components } from "./schema";

type Schemas = components["schemas"];
export type PublicConfig = Schemas["PublicConfig"];
export type ConsentText = Schemas["ConsentOut"];
export type StartSignIn = Schemas["StartSignIn"];
export type CandidateState = Schemas["CandidateState"];
export type CandidateDetails = Schemas["CandidateDetails"];
export type CvStatus = Schemas["CvStatus"];
export type IssuedToken = Schemas["IssuedToken"];

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

async function detailOf(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as { detail?: unknown };
    if (typeof body.detail === "string") return body.detail;
  } catch {
    // not JSON
  }
  return `Request failed (${response.status})`;
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, { credentials: "same-origin", ...init });
  if (!response.ok) throw new ApiError(response.status, await detailOf(response));
  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}

export function json(method: string, body: unknown): RequestInit {
  return { method, headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) };
}

export const api = {
  publicConfig: () => request<PublicConfig>("/api/config/public"),
  consent: () => request<ConsentText>("/api/consent"),
  startSignIn: (choices: StartSignIn) =>
    request<{ redirect_url: string }>("/api/auth/github/start", json("POST", choices)),
  me: () => request<CandidateState>("/api/me"),
  uploadCv: (file: File) =>
    request<CvStatus>("/api/cv", {
      method: "POST",
      headers: { "Content-Type": "application/octet-stream" },
      body: file,
    }),
  pasteCv: (text: string) => request<CvStatus>("/api/cv/text", json("POST", { text })),
  updateDetails: (details: CandidateDetails) =>
    request<CandidateDetails>("/api/me/details", json("PUT", details)),
  issueToken: () => request<IssuedToken>("/api/token", { method: "POST" }),
  logout: () => request<undefined>("/auth/logout", { method: "POST" }),
};
